import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

import { useTrans } from '~/hooks/useTrans';
import Loader from '~/components/Loader';

export type TReportsTableShowData = "projects" | "call" | "amount";

interface IAdminBillingExportTable {
	loading: boolean;
}

export default function AdminBillingExportTable({
	loading = true,
}: IAdminBillingExportTable) {
	const { trans } = useTrans();

	/* eslint-disable react/no-array-index-key */
	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
			</TableHead>
			<TableBody>
				<TableRow>
					<TableCell className="text-align-center">
						{ loading && <Loader msg={trans("loadingData")} /> }
					</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	</TableContainer>;
}
